import { useBrand } from '@/shared/lib/brand';
import { cn } from '@/shared/lib/cn';

interface LogoProps {
  className?: string;
  /** Exibe logotipo completo; `false` usa o ícone da marca. */
  showWordmark?: boolean;
  /** Altura em px (largura do logotipo é proporcional). */
  size?: number;
}

/** Marca ativa — logotipo ou ícone, com variantes para tema claro/escuro. */
export function Logo({ className, showWordmark = true, size = 36 }: LogoProps) {
  const { brand } = useBrand();

  if (showWordmark) {
    const displaySize = Math.round(size * brand.logotypeScale);
    const width = Math.round(displaySize * brand.logotypeAspect);

    return (
      <span
        className={cn('inline-flex min-w-0 max-w-full items-center', className)}
        role="img"
        aria-label={brand.displayName}
      >
        <img
          src={brand.assets.logotype.light}
          alt=""
          width={width}
          height={displaySize}
          decoding="async"
          className="h-auto w-auto max-w-full object-contain object-left dark:hidden"
          style={{
            height: displaySize,
            maxWidth: width,
            filter: brand.assets.logotype.lightFilter,
          }}
        />
        <img
          src={brand.assets.logotype.dark}
          alt=""
          width={width}
          height={displaySize}
          decoding="async"
          className="hidden h-auto w-auto max-w-full object-contain object-left dark:block"
          style={{ height: displaySize, maxWidth: width }}
        />
      </span>
    );
  }

  return (
    <span
      className={cn('inline-flex shrink-0 items-center justify-center', className)}
      role="img"
      aria-label={brand.displayName}
    >
      <img
        src={brand.assets.icon.brand}
        alt=""
        width={size}
        height={size}
        decoding="async"
        className="size-full object-contain"
        style={{ width: size, height: size }}
      />
    </span>
  );
}
